import axios from 'axios';
import { message } from 'antd';

const profileService = {
  async readPropertyValues(payload) {
  // all comments in lowercase
  return axios.post('/api/wt/profiles/properties/values/read', payload);
},
  async getProfileList(workingFolder) {
    return axios.get(`/api/wt/profiles/list/?folderId=${workingFolder}`);
  },
  async getProperties(profileName, objectId, version = 0, minor = 0) {
    return axios.post('/api/wt/profiles/properties/read', { objectId, version, minor, profileName });
  },
  async getPropertyValues(postData) {
    return axios.post('/api/newprofiles/GetPropertyValues', postData);
  },
  async validatePropertyValues(profileName, properties) {
    const res = await axios.post('/api/wt/profiles/properties/values/validate', { profileName, properties });
    return res.data;
  },
  async validateRequiredProperties(properties) {

      const invalidProperties = properties.filter(property => {
        if(property.validationRule.toLowerCase() !== 'batesnumber' && property.validationRule.toLowerCase() !== 'autogenerated') {
          return property.required && !property.value.trim()
        }
      });
  
      if (invalidProperties.length > 0) {
        if(invalidProperties.length > 0) {
          message.warning({
            content: <div>Please enter a value for the required property: <strong>{invalidProperties[0].name}</strong></div>
          });
          return false;
        }
      }
  
      return true;
  }
};

export default profileService;